import { useState, useEffect, useRef } from "react";
import cn from "classnames";
import Button from "../../audi-ui-components/Button";
import {
  requestTypes,
} from "./CVOConstants";

const nextStepBreakpoint = 450;

const NextStep = ({ children, className, image, title }) => {
  const wrapperRef = useRef(null);
  const [isLarge, setIsLarge] = useState(false);
  const update = (entries) => {
    let w = entries[0].contentRect.width;
    setIsLarge(w > nextStepBreakpoint);
  };
  useEffect(() => {
    const obs = new ResizeObserver(update);
    if (wrapperRef.current) {
      obs.observe(wrapperRef.current);
    }
    return () => {
      obs.disconnect();
    };
  }, []);
  return (
    <div ref={wrapperRef} className={cn("next-step", className, {"overbp": isLarge, "underbp": !isLarge})}>
      <img src={image} alt="" />
      <div className="next-step__inner">
        {title && <p className="next-step__title mb-4">{title}</p>}
        {children}
      </div>
    </div>
  )
}

const NextSteps = ({ requestType }) => {
  if (requestType === requestTypes.NO_LONGER_OWN) {
    return (
      <div className="row pb-5">
        <div className="col-12 col-small-6">
          <NextStep className="large" image={`${process.env.PUBLIC_PATH}img/A243841_large.jpg`} title="Searching for an upgrade?">
            <Button variant="primary" theme="light" href="https://www.audi.com.au/en/model-range/rs-range/">
              Discover the RS Range
            </Button>
          </NextStep>
        </div>
        <div className="col-12 col-small-6">
          <NextStep className="large" image={`${process.env.PUBLIC_PATH}img/AUDI0223_Q5_2024_7163_R1.jpg`} title="Explore the latest Audi models">
            <Button variant="primary" theme="light" href="https://www.audi.com.au/en/model-range/">
              <span className="btn-label-large">Explore now</span>
              <span className="btn-label-small">Explore the latest Audi models</span>
            </Button>
          </NextStep>
        </div>
      </div>
    );
  }

  if (requestType === requestTypes.NEW_OWNER || requestType === requestTypes.PERSONAL_DETAILS_CHANGED) {
    return (
      <div className="row pb-5">
        {requestType === requestTypes.NEW_OWNER && <div className="col-12 col-medium-4">
          <NextStep image={`${process.env.PUBLIC_PATH}img/AusGP_event_myaudi.jpg`}>
            <Button variant="primary" theme="light" href="https://myaudi.com.au/">
              Join myAudi
            </Button>
          </NextStep>
        </div>}
        {requestType === requestTypes.PERSONAL_DETAILS_CHANGED && <div className="col-12 col-medium-4">
          <NextStep image={`${process.env.PUBLIC_PATH}img/dynamic-experience.jpg`}>
            <Button variant="primary" theme="light" href="https://myaudi.com.au/audi-experience">
              Discover Audi Experience
            </Button>
          </NextStep>
        </div>}
        <div className="col-12 col-medium-4">
          <NextStep image={`${process.env.PUBLIC_PATH}img/q5_suv_hero.jpg`}>
            <Button variant="primary" theme="light" href="https://www.audi.com.au/en/owners/service/">
              Explore owner benefits
            </Button>
          </NextStep>
        </div>
        <div className="col-12 col-medium-4">
          <NextStep image={`${process.env.PUBLIC_PATH}img/AUDI0204_sq6_2023_5327_cast.jpg`}>
            <Button variant="primary" theme="light" href="https://store.audi.com.au/">
              Discover accessories
            </Button>
          </NextStep>
        </div>
      </div>
    );
  }
  if (requestType === requestTypes.WRITTEN_OFF) {
    return (
      <div className="row pb-5">
        <div className="col-12 col-small-6">
          <NextStep image={`${process.env.PUBLIC_PATH}img/AUDI0223_Q5_2024_7163_R1.jpg`}>
            <Button variant="primary" theme="light" href="https://www.audi.com.au/en/offers/">
              View our latest offers
            </Button>
          </NextStep>
        </div>
        <div className="col-12 col-small-6">
          <NextStep image={`${process.env.PUBLIC_PATH}img/audi-insurance.jpg`}>
            <Button variant="primary" theme="light" href="https://www.audi.com.au/en/financial-services/insurance/">
              Explore Audi Insurance
            </Button>
          </NextStep>
        </div>
      </div>
    );
  }
  return null;
};

export default NextSteps;
